import React from 'react';
import loadable from '@loadable/component';
import parse from 'html-react-parser';
import { roomSizeStatic } from '../../static-data/productStatic';
import { SUPPORTED_REGIONS } from '../../../shared/enums';

import CCStatsGraphLgPng from '../../../assets/images/products/CC-stats-graph-lg.png';
import CCStatsGraphLgWebp from '../../../assets/images/products/CC-stats-graph-lg.png?as=webp';
import CCStatsGraphSmPng from '../../../assets/images/products/CC-stats-graph-sm.png';
import CCStatsGraphSmWebp from '../../../assets/images/products/CC-stats-graph-sm.png?as=webp';

const ImageLoader = loadable(() => import('../common/ImageLoader'));

const ProductStats = ({ localization, type }) => {
  const { region } = localization;
  const regional = SUPPORTED_REGIONS[region] || SUPPORTED_REGIONS.US;

  const size = roomSizeStatic[type][regional].dander;

  return (
    <div
      className='product-stats'
      style={{ '--primary-color': '#F42C52', '--tertiary-color': '#0F0305' }}
    >
      <span className='product-stats__shape' />
      <div className='container container--md'>
        <div className='product-stats__header'>
          <h2 className='product-stats__title'>
            Mila’s H13 HEPA filter clears out 99.5% more airborne pet dander.
          </h2>
          <div className='product-stats__description'>
            <p>
              Mila is today’s must have cleaning device for all households with
              pets. Third-party lab tests show Mila can effectively filter out
              99.5% more dander in an average sized bedroom in less than 30
              minutes.
            </p>
          </div>
        </div>
        <ImageLoader
          className='product-stats__image img-relative'
          placeholderAspectRatio={630 / 471}
          image={CCStatsGraphLgPng}
          webp={CCStatsGraphLgWebp}
          smallImage={CCStatsGraphSmPng}
          smallWebp={CCStatsGraphSmWebp}
          alt='Mila’s H13 HEPA filter clears out 99.5% more airborne pet dander'
        />
        <div className='product-stats__content'>
          <p>
            <strong>Results:</strong>
            {' '}
            While Mila can’t prevent your pet bird,
            cat, dog, critter from releasing dander, she does her best to keep
            it from lingering in the air and out of your lungs. These studies
            show Mila can rapidly dilute the concentration of airborne dander –
            which can often float in the air for hours — and is proven to be
            99.5% MORE effective at filtering dander out compared to leaving it
            to its own devices.
            {' '}
          </p>
          <p>
            <strong>Methodology (for geeks/geekettes 🤓):</strong>
            {' '}
            Mila was
            independently tested by Intertek Labs in a
            {' '}
            {parse(`${size}`)}
            {' '}
            stainless-steel chamber for its multi-pass dander
            filtration efficiency against dander using ANSI/AHAM AC-1 2020, the
            methodology used to test the efficacy of household air cleaners.
          </p>
        </div>
      </div>
    </div>
  );
};

export default ProductStats;
